import { useQuery } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";
import { ApiResponse } from "../../../types/api-response";
import axios from "../../../utils/axiosInceptor";
import { getLoginResponse } from "../../../utils/session";
import { apiV1Endpoint } from "../endpoints";
import { Organization } from "./types";

export const getOrganization = async (orgId: string, params?: AxiosRequestConfig["params"]) => {
  const url = `${apiV1Endpoint}/organization/${orgId}`;
  const response = await axios.get<ApiResponse<Organization>>(url, {
    params,
  });

  return response.data.result;
};

export type UseGetOrganizationOptions = {
  params?: AxiosRequestConfig["params"];
  isEnabled?: boolean;
  staleTimeInfinity?: boolean;
};

export const useGetOrganization = (options: UseGetOrganizationOptions = {}) => {
  const { params, isEnabled = true, staleTimeInfinity = false } = options;

  const { orgId } = getLoginResponse() ?? {};

  const { data, isLoading, isSuccess, refetch } = useQuery({
    queryKey: ["organization", params?.filterkeys ?? params],
    queryFn: () => getOrganization(orgId ?? "", params),
    enabled: Boolean(orgId) && isEnabled,
    networkMode: "always",

    ...(staleTimeInfinity
      ? {
          staleTime: Infinity,
          refetchOnWindowFocus: false,
          refetchOnReconnect: false,
          refetchOnMount: false,
        }
      : {
          staleTime: 5 * 60 * 1000,
          refetchOnWindowFocus: false,
        }),
  });

  return {
    organization: data,
    isLoadingOrganization: isLoading,
    isSuccessOrganization: isSuccess,
    refetchOrganization: refetch,
  };
};
